import React from 'react';
import { Button, Divider, Modal, Typography } from 'antd';
import deleteSvg from '@assets/images/user/delete.svg'; // Import your SVG image
import './DeleteModal.css';
import { useMutation } from 'react-query';
import { showError, showSuccess } from '@components/notification';
import rootApi from '@utils/baseAPI/WrapperApi';
import { useNavigate } from 'react-router-dom';
const { Text } = Typography;

const DeleteConfirmationModal = ({ visible, setVisible, userInfo, refetch }) => {
  const navigate = useNavigate();
  const { mutateAsync, isLoading } = useMutation('delete-operator', () => {
    return rootApi.delete(`/api/user/${userInfo.id}`);
  });

  const handleConfirm = () => {
    mutateAsync()
      .then(() => {
        setVisible(false);
        !refetch && navigate(`/users`);
        showSuccess({ message: 'Vô hiệu hoá người dùng thành công' });
        refetch && refetch();
      })
      .catch((error) => {
        showError(error?.message || 'Vui lòng liên hệ admin để được hỗ trợ');
      });
  };

  return (
    <Modal
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" style={{ height: '36px' }} onClick={() => setVisible(false)}>
          Hủy
        </Button>,
        <Button
          key="submit"
          style={{ backgroundColor: '#10b981', color: '#FFFF', height: '36px' }}
          onClick={handleConfirm}>
          Xác nhận
        </Button>
      ]}
      className="delete-modal">
      <div className="delete-icon-container">
        <img src={deleteSvg} alt="Delete Icon" className="delete-icon" />
        <Text style={{ marginTop: '8px', display: 'block', fontSize: '18px', fontWeight: 600 }}>
          Vô hiệu hoá người dùng
        </Text>
        <Text
          style={{
            marginTop: '8px',
            display: 'block',
            color: 'var(--muted)',
            fontSize: '14px',
            fontWeight: 400
          }}>
          Bạn có chắc chắn muốn vô hiệu hoá người dùng <strong>{userInfo?.user_name}</strong>?
        </Text>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
